<div class="titles-wrapper">
    <div class="title-container">
        <p>Título</p>
        <input class="custom-input mb-2" type="text" [(ngModel)]="tool.title">

        <input class="colorpicker-input" [(ngModel)]="colors.title"
        [value]="colors.title"
        [style.background]="colors.title"
        [(colorPicker)]="colors.title">
    </div>
    <div class="title-container">
        <p>Subtítulo</p>
        <input class="custom-input mb-2" type="text" [(ngModel)]="tool.subtitle">
        <input class="colorpicker-input" [(ngModel)]="colors.subtitle"
        [value]="colors.subtitle"
        [style.background]="colors.subtitle"
        [(colorPicker)]="colors.subtitle">
    </div>
    <div class="title-container">
        <p>Background</p>
        <input class="colorpicker-input mt-2" [(ngModel)]="colors.background"
        [value]="colors.background"
        [style.background]="colors.background"
        [(colorPicker)]="colors.background">
    </div>
</div>